"use strict";
function initRun(app) {
    /* @ngInject */
    app.run(function ($rootScope, $analytics, $location, layoutInitService, BASE_URL) {
        $rootScope.clearLoadingError = function () {
            $rootScope.loadingError = false;
        };
        $rootScope.$on("$routeChangeStart", function (event, next, current) {
            $rootScope.loadingError = false;
            //refresh scenario
            if (!current) {
                layoutInitService();
            }
            if (next.redirectTo === "/") {
                event.preventDefault();
            }
            if (next.resolve) {
                // Show a loading message until promises aren't resolved
                $rootScope.loadingView = true;
            }
        });
        $rootScope.$on("$routeChangeSuccess", function () {
            // Hide loading message
            $rootScope.loadingView = false;
            $analytics.pageTrack("" + BASE_URL + $location.path());
        });
        $rootScope.$on("$routeChangeError", function () {
            // Hide loading message
            $rootScope.loadingView = false;
            $rootScope.loadingError = true;
        });
    });
}
exports.initRun = initRun;



/** WEBPACK FOOTER **
 ** ./app/app-run/app.run.ts
 **/